export default function ApplicationCTA() {
  const handleFormClick = () => {
    window.open('https://ws.formzu.net/dist/S274768490/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-cyan-50 to-blue-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            応募・お問い合わせ
          </h2>
          <p className="text-xl text-gray-700 mb-12 leading-relaxed">
            まずはお気軽にご連絡ください。<br />
            あなたの「まごころ」を一緒に届けましょう。
          </p>

          <div className="bg-white rounded-3xl shadow-xl p-12 mb-8">
            <div className="grid md:grid-cols-2 gap-8">
              <a 
                href="tel:046-845-4175" 
                className="flex flex-col items-center gap-4 p-8 rounded-2xl border-2 border-cyan-500 hover:bg-cyan-50 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-cyan-500 rounded-full group-hover:scale-110 transition-transform">
                  <i className="ri-phone-line text-4xl text-white"></i>
                </div>
                <div>
                  <p className="text-lg font-medium text-gray-900 mb-2">お電話でのお問い合わせ</p>
                  <p className="text-3xl font-bold text-cyan-600">046-845-4175</p>
                  <p className="text-sm text-gray-600 mt-2">受付時間:平日 9:00〜18:00</p>
                </div>
              </a>

              <button
                onClick={handleFormClick}
                className="flex flex-col items-center gap-4 p-8 rounded-2xl bg-cyan-500 hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer group"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full group-hover:scale-110 transition-transform">
                  <i className="ri-mail-line text-4xl text-cyan-500"></i>
                </div>
                <div>
                  <p className="text-lg font-medium text-white mb-2">フォームでのお問い合わせ</p>
                  <p className="text-2xl font-bold text-white flex items-center gap-2 justify-center">
                    お問い合わせフォームへ
                    <i className="ri-external-link-line"></i>
                  </p>
                  <p className="text-sm text-cyan-100 mt-2">24時間受付</p>
                </div>
              </button>
            </div>
          </div>

          <div className="space-y-4 text-left bg-white rounded-2xl p-8 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
              <i className="ri-information-line text-cyan-500"></i>
              応募に関するご案内
            </h3>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-cyan-500 mt-1"></i>
                <span>面接日程は柔軟に対応いたします。お気軽にご相談ください。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-cyan-500 mt-1"></i>
                <span>未経験者の方も大歓迎です。丁寧な研修制度をご用意しています。</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-cyan-500 mt-1"></i>
                <span>職場見学も随時受け付けております。実際の雰囲気をご覧ください。</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
